import React from "react";
import Th from "./Th";
import Td from "./Td";
import CardTitle from "./CardTitle";
import StatusBadge from "./StatusBadge";
import GroupedTripLink from "./GroupedTripLink";
import SearchBox from "./SearchBox";
import useTripSearch from "./useTripSearch";
import { formatDate } from "./helpers";
import { CARD_SURFACE } from "./constants";

// Standalone "Flagged Trips" table (formerly the Issues panel). Lists grouped
// trips that need attention — cancelled-early plus in-progress states — with a
// Reason column and its own header search.
//
// Module-level so useTripSearch's memo keeps a stable identity.
const SEARCH_FIELDS = ["reason"];

const FlaggedTripsTable = ({ flaggedTrips = [] }) => {
  const [filtered, search, setSearch] = useTripSearch(flaggedTrips, SEARCH_FIELDS);

  return (
    <section className="bg-white overflow-hidden" style={CARD_SURFACE}>
      <div className="px-6 py-4 flex justify-between items-center" style={{ gap: 16 }}>
        <CardTitle>Flagged Trips ({flaggedTrips.length})</CardTitle>
        <SearchBox value={search} onChange={setSearch} />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead className="border-b border-gray-200">
            <tr>
              <Th>Grouped Trip ID</Th>
              <Th>Date &amp; Time</Th>
              <Th align="right">Duration</Th>
              <Th align="right">Distance</Th>
              <Th>Reason</Th>
              <Th>Status</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-center text-sm text-gray-500 italic">
                  {search ? "No flagged trips match your search." : "No flagged trips this week."}
                </td>
              </tr>
            ) : (
              filtered.map((trip) => (
                <tr key={trip.id} className="hover:bg-gray-100">
                  <Td>
                    <GroupedTripLink id={trip.id} label={trip.grouped_trip_code} />
                  </Td>
                  <Td>{formatDate(trip.occurred_at)}</Td>
                  <Td align="right">{trip.duration_min} mins</Td>
                  <Td align="right">{trip.distance_km?.toFixed(1)} km</Td>
                  <Td>{trip.reason || "—"}</Td>
                  <Td plain>
                    <StatusBadge status={trip.status} />
                  </Td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default FlaggedTripsTable;
